export const SCORE_LOW = 30
export const SCORE_HIGH = 70

// Point for health
export const SCORE_HEALTH = {
  low: 30,
  high: 70,
}

export const SCORE_SUMMARY = {
  low: 30,
  high: 70,
}

export const SCORE_HEALTH_REDUCE = {
  low: 10,
  high: 90,
}
